import "bootstrap/dist/css/bootstrap.min.css"
import { createApp } from 'vue'
import App from './App.vue'
import store from './store'

const app = createApp(App)

import bootstrap from "bootstrap/dist/js/bootstrap.js"

app.use (store) ;
app.use( {
  install: (app) => {
      app.config.globalProperties.$getabspos = (el) => 
      {
        let el2 = el;
        let curtop = 0;
        let curleft = 0;
        if (document.getElementById || document.all) {
            do  {
                curleft += el.offsetLeft-el.scrollLeft;
                curtop += el.offsetTop-el.scrollTop;
                el = el.offsetParent;
                el2 = el2.parentNode;
                while (el2 != el) {
                    curleft -= el2.scrollLeft;
                    curtop -= el2.scrollTop;
                    el2 = el2.parentNode;
                }
            } while (el.offsetParent);
        } else if (document.layers) {
            curtop += el.y;
            curleft += el.x;
        }
        return { 'top' : curtop, 'left' :  curleft } ;
    }
  }
}) ;
app.use(bootstrap).mount('#app')


